export const DEMO_MODE = true;

export const DEMO_USER = {
  _id: 'demo-user-001',
  userId: 'demo-user-001',
  name: '示範用戶',
  image: 'https://i.pravatar.cc/100?img=3',
  introduce: '攀岩 2 年 | 挑戰 V5 中 🔥',
};
